import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    big: {
        color: "rgb(138, 66, 208)",
        animation: "$flash 2s infinite ease-in-out",
        transformOrigin: "center center",
    },
    small: {
        color: "rgb(138, 66, 208)",
        animation: "$flash 2s infinite ease-in-out 0.2s", // dellay
        transformOrigin: "center center",
    },
    "@keyframes flash": {
        "0%": { opacity: 1, transform: "scale(0.9)" },
        "10%": { opacity: 0.2, transform: "scale(1.2)" },  // blink
        "30%": { opacity: 1, transform: "scale(0.9)" },
        "100%": { opacity: 1, transform: "scale(0.9)" }, // stop
    },
}));

export default function SparkleIcon() {
    const classes = useStyles();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="32"
            height="32"
            fill="currentColor"
            role="img"
            aria-label="AI sparkle"
        >
            {/* big star */}
            <path
                className={classes.big}
                d="M12 4l1.8 3.6L18 9.2l-4.2 1.6L12 15l-1.8-4.2L6 9.2l4.2-1.6L12 4z"
            />
            {/* small start */}
            <path
                className={classes.small}
                d="M18 15l.9 1.8L21 18l-2.1.9L18 21l-.9-2.1L15 18l2.1-.9L18 15z"
            />
        </svg>
    );
}
